// apiHandler.js
import axiosClient from "./axiosInstance";

/**
 * Universal API handler
 * @param {string} method - GET | POST | PUT | DELETE
 * @param {string} url - API endpoint (without baseURL)
 * @param {object} [data] - Request body (for POST, PUT)
 * @param {object} [params] - Query parameters (for GET)
 * @returns {object} - { success: boolean, data?, message? }
 */
export async function apiRequest(method, url, data = {}, params = {}) {
    return new Promise(async (resolve) => {
        try {

            const config = {
                method,
                url,
                params,
            };



            // 🟢 Agar data diya gaya hai, to attach karo
            if (data !== null && data !== undefined) {
                config.data = data;

                // Agar FormData hai to headers ko automatically handle karne do
                if (data instanceof FormData) {
                    // Content-Type header manually mat set karo
                    // Axios automatically 'multipart/form-data' set karega with boundary
                    config.headers = {
                        ...config.headers,
                        'Content-Type': 'multipart/form-data',
                        // Authorization header yahan bhi add karo agar required ho
                    };
                } else {
                    // Normal JSON data ke liye
                    config.headers = {
                        ...config.headers,
                        'Content-Type': 'application/json',
                    };
                }
            }
            const response = await axiosClient(config);

            resolve({
                success: true,
                data: response.data,
            });

        } catch (error) {
            let message = "Something went wrong!";
            if (error.response) {
                message = error.response.data?.message || `Error: ${error.response.status}`;
            } else if (error.request) {
                message = "Network error! Please check your internet connection.";
            } else {
                message = error.message;
            }

            if (message === "Invalid token.") {
                // Handle token expiration (e.g., redirect to login)
                window.sessionStorage.removeItem("user");
                window.localStorage.removeItem("token");
                window.location.href = "/login";
            }


            resolve({
                success: false,
                message,
            });
        }
    })
}
